/* eslint-disable */
import { TagCanvas } from "./TagCanvas.js";
 import React, { useEffect } from 'react';
import data from './skills.json';
function Tag () {
    useEffect(() => {
      console.log('Loading TagCanvas...');
      const TagCanvas = window.TagCanvas;
      const tagCanvasOptions = {
        textColour: '#023830',
        outlineThickness: 0.5,
        outlineColour: '#FE0853',
        maxSpeed: 0.06,
        freezeActive: true,
        shuffleTags: true,
        shape: 'sphere',
        zoom: 0.8,
        wheelZoom: false,
        noSelect: true,
        textFont: null,
        freezeDecel: true,
        fadeIn: 3000,
        initial: [0.3, -0.1],
        depth: 1.1,
      };
      try {
        TagCanvas.Start('tagcanvas', 'taglist', tagCanvasOptions);
      } catch (e) {
        console.log('Canvas error.');
        console.log(e);
      }
    }, []);

return (
  <div className='container'>
    <canvas
      id='tagcanvas'
      width='840'
      height='600'
      style={{
        maxWidth: '1000px',
        width: '100%',
        zIndex: '99',
        position: 'relative',
        margin: '0 auto',
      }}
    ></canvas>
    <div id='taglist' style={{ display: 'none' }}>
      <ul>
        {data.map((item, index) => (
          <li key={index}>
            <a href="">{item.title}</a>
          </li>
        ))}
      </ul>
    </div>
  </div>
)}

export default Tag;